module.exports = __webpack_public_path__ + "img/bg_compas.df00bca3.png";